export enum LANG {
    FR = 'fr',
    EN = 'en',
    NL = 'nl'
}

export enum LANGUAGE {
    FR = 'Français',
    EN = 'English',
    NL = 'Dutch'
}